require('./style.less');

var DropDown = require('../../../../common/dropDown/dropDownContentView'), //
    $ = require('jquery'),
    fvChannel = require('glRadio').channel('FV');

module.exports = DropDown.extend({
    template: require('./noteFilterDD.hbs'),
    initialize: function(options) {
        DropDown.prototype.initialize.call(this, options);
        _.extend( this, _.pick(options, 'filterModel', 'notes') );
    },
    templateOptions: function() {

        var allNotes = this.notes,
            allVisibleNotes = allNotes.getVisibleNotes(),  //getVisibleNoteModels(allNotes.models);
            currentPgNumber = this.options.channel.request('currentPageNumber'),
            fm = this.filterModel,
            hideActivityNotes = fm.hideActivityNotes(); // (means the 'filter is applied')

        /* Template data for note types section -- now 'noteTypeGroups' */
        var uniqueNoteTypesInNotesCollection = allNotes.chain()
            .uniq( function(m) {
                return m.noteTypeGroup;
            })
            .map( function(m) {
                var notesOfType = allNotes.getNotesOfGroupType( m.noteTypeGroup ),
                    visibleNotesOfType = allNotes.getVisibleNotes( notesOfType );

                return _.extend( {}, m , {
                    nVisible: visibleNotesOfType.length,
                    nTotal: notesOfType.length,
                    // don't allow selection of the menu item under certain circumstances -- logic could probably be expanded
                    disable:
                    ( m.isDocument && fm.isCurrentPageFilterApplied() ) ||
                        (hideActivityNotes && m.noteTypeGroup === 'ACTIVITY_NOTE')
                });

            })
            .sortBy( function(m) {
                return m.desc;
            })
            .value();

        // Referrals Section
        var allReferredNotes = allNotes.filter( function(n) {
                return n.consultGroupsAssigned();
            }),
            allUnreferredNotes = allNotes.filter( function(n) {
                return !n.consultGroupsAssigned();
            }),
            visibleReferredNotes = allNotes.getVisibleNotes(allReferredNotes),
            visibleUnreferredNotes = allNotes.getVisibleNotes(allUnreferredNotes);

        return {
            pageSection: {
                all: {
                    nVisible: allVisibleNotes.length,
                    nTotal: allNotes.length
                },
                currentPage: {
                    showFilter: this.options.channel.request('viewMode') !== 'pdf',
                    nVisible:  _.filter(allVisibleNotes, function(n) {
                        return n.pageNumber === currentPgNumber;
                    }).length,
                    nTotal: allNotes.getNotesOfPage( currentPgNumber ).length
                }
            },
            typeSection: {
                existingNoteTypes: uniqueNoteTypesInNotesCollection
            },
            activitySection: {
                showSection: fm.get('noteTypeFilter') !== 'ACTIVITY_NOTE',
                showActivityNotes: !hideActivityNotes // active set in template, not via jQ in onRender
            },
            referralSection: {
                showSection: fvChannel.request('supportConsults'),
                referred: {
                    nVisible: visibleReferredNotes.length,
                    nTotal: allReferredNotes.length
                },
                notReferred: {
                    nVisible: visibleUnreferredNotes.length,
                    nTotal: allUnreferredNotes.length
                }
            }
        };

    },
    ui: {
      noteTypeMenuItems:                    '.dd-grp-note-types .mi',
      pageMenuItems:                        '.dd-grp-page .mi',
      activityMenuItems:                    '.dd-grp-activity .mi',
      referralMenuItems:                    '.dd-grp-referrals .mi'
    },
    events: {
        'click @ui.noteTypeMenuItems':      'changeNoteType',
        'click @ui.pageMenuItems':          'changePageType',
        'click @ui.activityMenuItems':      'toggleActivityNotes',
        'click @ui.referralMenuItems':      'changeReferralType'
    },
    onAfterSwapEl: function() {
        this._postRender();
    },
    /* (initial render and swap of dd contents */
    _postRender: function() {

        var fm = this.filterModel;

        this.$('[data-group-note-type="' + fm.get('noteTypeFilter') + '"]').addClass('active');
        this.$('[data-pg-type="' + fm.get('pageFilter') + '"]').addClass('active');
        this.$('[data-referral-filter-type="' + fm.get('referralFilter') + '"]').addClass('active');

    },
    
    //TODO: need to send all the types from the filter model or the one that just changed?
    changeNoteType: function(e) {
        var $target = $(e.currentTarget); //look into taking out of each cb via event delegation
        if ($target.hasClass('disabled'))
            return false;

        this.options.channel.command('updateFilter', _.extend( this._getBaseUpdateFilterOptions(), {
            noteType:  $target.data('groupNoteType')
        }));
    },
    changePageType: function(e) {
        var $target = $(e.currentTarget);
        if ($target.hasClass('disabled')) return false;
        this.options.channel.command('updateFilter', _.extend( this._getBaseUpdateFilterOptions(), {
            page: $target.data('pgType')
        }));

    },
    toggleActivityNotes: function(e) {
        var $target = $(e.currentTarget);
        if ($target.hasClass('disabled')) return false;
        this.options.channel.command('updateFilter', _.extend( this._getBaseUpdateFilterOptions(), {
            hideActivityNotes: $target.text() === 'Hide'
        }));
    },
    changeReferralType: function(e) {
        var $target = $(e.currentTarget); //wouldn't apply
        if ($target.hasClass('disabled')) return false;
        this.options.channel.command('updateFilter', _.extend( this._getBaseUpdateFilterOptions(), {
            referralFilter: $target.data('referral-filter-type')
        }));
    },
    _getBaseUpdateFilterOptions: function() {
        var fm = this.filterModel;
        return {
            filterSrc: 'dropdown',
            page:  fm.get('pageFilter'),
            noteType:  fm.get('noteTypeFilter'),
            hideActivityNotes: fm.get('hideActivityNotes'),
            referralFilter: fm.get('referralFilter'),
            currentPage: this.options.channel.request('currentPageNumber')
        };
    }
});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/header/filter/filterMenu.js
 ** module id = 492
 ** module chunks = 0
 **/